import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/axios';

// Fetch all offices
export const fetchOffices = createAsyncThunk(
  'offices/fetchOffices',
  async (companyId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/api/admin/offices?company_id=${companyId || ''}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to load offices');
    }
  }
);

export const createOffice = createAsyncThunk(
  'offices/createOffice',
  async (officeData, { rejectWithValue }) => {
    try {
      const response = await api.post('/api/admin/offices', officeData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to create office');
    }
  }
);

export const updateOffice = createAsyncThunk(
  'offices/updateOffice',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/api/admin/offices/${id}`, data);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to update office');
    }
  }
);

export const deleteOffice = createAsyncThunk(
  'offices/deleteOffice',
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`/api/admin/offices/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to delete office');
    }
  }
);

const officeSlice = createSlice({
  name: 'offices',
  initialState: {
    offices: [],
    status: 'idle',
    error: null,
  },
  reducers: {
    clearOfficeError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchOffices.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchOffices.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.offices = action.payload;
      })
      .addCase(fetchOffices.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      // Create
      .addCase(createOffice.fulfilled, (state, action) => {
        state.offices.push(action.payload);
      })
      // Update
      .addCase(updateOffice.fulfilled, (state, action) => {
        const index = state.offices.findIndex(o => o.id === action.payload.id);
        if (index !== -1) {
          state.offices[index] = action.payload;
        }
      })
      // Delete
      .addCase(deleteOffice.fulfilled, (state, action) => {
        state.offices = state.offices.filter(o => o.id !== action.payload);
      });
  },
});

export const { clearOfficeError } = officeSlice.actions;
export default officeSlice.reducer;
